import { render, staticRenderFns } from "./card_pointe.vue?vue&type=template&id=076e8c60&"
import script from "./card_pointe.vue?vue&type=script&lang=js&"
export * from "./card_pointe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports